import { Entity } from '@backstage/catalog-model';
import { isAllureReportAvailable } from '@backstage-community/plugin-allure';

/**
 * The "Allure Report" tab is for Components only. `defaultEntityPage` is also the
 * fallback layout for other kinds, so the annotation alone must not show the tab.
 * The kind is compared case-insensitively, like `EntitySwitch`'s `isKind`.
 */
export function isAllureTabAvailable(entity: Entity): boolean {
  return (
    entity.kind.toLowerCase() === 'component' && isAllureReportAvailable(entity)
  );
}
